// Google Analytics
var analyticsId = 'UA-15325774-45';
var pageName = analyticsId;

$(document).ready(function () {
    
    // Page timeout
    if ( isPage('Exam Center Question Page | Exam Center Application') && ($('#answerTimer').length) ) {
        var timeout = 15*60*1000; // A shade less than 15 minutes
        var leave = function() {
            alert('We\'re sorry. Your exam has timed out.');
            location.href = '../timeout.html';
            }
        };
        window.setTimeout(leave, timeout);
    }
    
    // Cancel exam
    $('#questionCancel').on('click', function(){
        confirm('Are you sure you want to cancel this exam? You will lose all progress.');
    });

    // Question functions
    if ( isPage('Exam Center Question Page | Exam Center Application') || isPage('Exam Center Question Bank Page | Exam Center Application') ) {

        // Load the entities
        $.getJSON('/exam-center/getSectionProgress.rest', function (response) {

            var length = response.length;

            if (length <= 0) {
                // TODO : Handle NULL Response
            }

            var sidebarHeading = document.createElement('h3');
            sidebarHeading.innerHTML = 'Exam Progress';
            document.getElementById('sidebarProgress').appendChild(sidebarHeading);

            // Populate ul - li with QuestionBank Name and Answered Questions Progress            
            $.each(response.bankProgress, function (key, value) {
                var sidebarListItem = document.createElement("li");
                var scoreProgress = ": ".concat("(").concat(value).concat(")");
                sidebarListItem.innerHTML = key.concat(scoreProgress);
                document.getElementById('sidebarProgress').appendChild(sidebarListItem);
            });
        }); // END REST call
    } // END question page
}); /* /document.ready */